import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import { GENDERS, TITLES } from '../../../../framework/constants/profile';
import { PHONE_PREFIX_DEFAULT, PHONE_PREFIXES } from '../../../../framework/constants/forms';
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
const fields = [
    { name: 'deliveryAddress',
        fields: [
            {
                name: 'gender',
                placeholder: 'forms.contactForm.placeholdersRequired.gender',
                extra: GENDERS,
                rules: 'required',
                output: (valueObj) => {
                    return valueObj ? valueObj.value : null;
                }
            },
            {
                name: 'title',
                placeholder: 'forms.contactForm.placeholdersRequired.title',
                rules: 'required',
                extra: TITLES,
                output: (valueObj) => {
                    return valueObj ? valueObj.value : null;
                }
            },
            {
                name: 'firstName',
                label: 'forms.contactForm.placeholdersRequired.firstName',
                rules: 'required|string',
                output: (value) => value ? value : null
            },
            {
                name: 'lastName',
                label: 'forms.contactForm.placeholdersRequired.lastName',
                rules: 'required|string',
                output: (value) => value ? value : null
            },
            {
                name: 'street',
                label: 'forms.contactForm.placeholdersRequired.street',
                rules: 'required|string',
                output: (value) => value ? value : null
            },
            {
                name: 'number',
                label: 'forms.contactForm.placeholdersRequired.number',
                rules: 'required|string',
                output: (value) => value ? value : null
            },
            {
                name: 'zip',
                label: 'forms.contactForm.placeholdersRequired.postCode',
                rules: 'required|numeric|postcode',
                output: (value) => value ? value : null
            },
            {
                name: 'city',
                label: 'forms.contactForm.placeholdersRequired.city',
                rules: 'required|string',
                output: (value) => value ? value : null
            },
            {
                name: 'phoneMain',
                label: 'modals:offerRequest.phoneMain',
                placeholder: 'modals:offerRequest.phoneMainPlaceholder',
                fields: [
                    {
                        name: 'countryCode',
                        placeholder: 'forms.contactForm.placeholdersRequired.countryCode',
                        extra: PHONE_PREFIXES,
                        value: PHONE_PREFIX_DEFAULT,
                        rules: 'required'
                    },
                    {
                        name: 'areaCode',
                        label: 'forms.contactForm.placeholdersRequired.areaCode',
                        type: 'tel',
                        rules: 'required|phone_areaCode'
                    },
                    {
                        name: 'phoneNumber',
                        label: 'forms.contactForm.placeholdersRequired.phoneNumber',
                        type: 'tel',
                        rules: 'required|phone' //required|phone || required|phone_phoneNumber
                    }
                ],
                output: (value) => {
                    const { countryCode, areaCode, phoneNumber } = value;
                    return `${countryCode ? countryCode : ''}${areaCode}${phoneNumber}`;
                }
            },
            {
                name: 'company',
                label: 'forms.contactForm.placeholders.company',
                rules: 'string',
                output: (value) => value ? value : null
            },
            {
                name: 'id',
                type: 'number',
                output: (value) => value ? value : null
            }
        ]
    }
];
const hooks = {
    onError(form) {
        console.log('Form errors', form.errors());
    }
};
const options = {
    validateOnChange: true,
    validateOnInit: false
};
export default new MobxReactForm({ fields }, { plugins, hooks, options });
